import { useAuth } from '@screentone/addon-auth-wrapper';

import type { AtLeastOne } from 'types/helpers';
import { ROLE_TYPE } from './types';

const useRoles = (...roles: AtLeastOne<ROLE_TYPE>) => {
  const { userAccess, currentProperty } = useAuth();

  if (roles.length === 0) {
    throw new Error('You MUST provide at least one role to the useRoles hook');
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const role of roles) {
    const fullRole = role === ROLE_TYPE.ADMIN ? ROLE_TYPE.ADMIN : `${currentProperty ?? ''}:${role}`;

    if (userAccess(fullRole)) {
      return true;
    }
  }

  return false;
};

export default useRoles;
